var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Data"}},[_c('div',{staticClass:"tab-text"},[_c('data-table')],1)]),_c('vs-tab',{attrs:{"label":"Export"}},[_c('div',{staticClass:"tab-text"},[_c('export')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }